import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { marketingGroupQueryKeys } from "./queryKeys";
import { IMarketingGroup } from "./../../models/marketingGroup/MarketingGroup";
import useQSBuilder from "../../hooks/useQSBuilder";

export function useMarketingGroups(includeInactive = false) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const marketingGroups = useQuery({
    queryKey: marketingGroupQueryKeys.all(includeInactive),
    queryFn: () =>
      get(`/marketing/group${buildQs({ includeInactive })}`) as unknown as IDefaultResponseWithData<
        IMarketingGroup[]
      >,
    refetchOnWindowFocus: false,
  });

  return {
    marketingGroups,
  };
}
